// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_sim_bob_terminal_ui_styles" + "." + "955f7f61" + ".chunk.css";
};